export const ON_CLICK_CONTENT_TYPE = "cre:none:impress";
export const PAGE_LOAD_TOOL = "event:credit prequal:start";
export const ELIGIBILITY_RESULT_PAGE_NAME = "brand:credit:prequal:eligibility checker:form complete";
export const ELIGIBILITY_RESULT_TOOL = "event:credit prequal:complete";
export const FORM_ERRORS_PAGE_NAME = "brand:credit:prequal:eligibility checker:form start:error";
export const FORM_ERRORS_TRACKING_PREFIX = "credit:prequal form";
export const FORM_ERRORS_EVENT_ACTION = "errorTracking";

export const PAGE_LOAD_TRACK_EVENT = "creditPrequalStart";
export const ELIGIBILITY_RESULT_TRACK_EVENT = "creditPrequalComplete";
export const FORM_ERRORS_TRACK_EVENT = "errorPage";